import { FC, useState } from 'react'

import { Cluster, Radio, Stack, Typography } from '@forto-dev/phoenix-ui-core'

import { SurveyQuestionProps, SurveyQuestionStatus } from '../domain/survey/surveyQuestionProps'
import { useRenderSurveyText } from '../hooks/survey/useRenderSurveyText'

export const RadioSurveyQuestion: FC<SurveyQuestionProps> = ({ question, onChange }) => {
  const { render } = useRenderSurveyText()
  const [value, setValue] = useState('')

  return (
    <Stack gap={16}>
      <Typography variant="body">{render(question)}</Typography>
      <Stack gap={8}>
        {question.responses.map((response) => (
          <Cluster y="start" key={response.id}>
            <Radio
              name="survey-questions-radio"
              checked={value === response.id}
              onChange={() => {
                setValue(response.id)
                onChange({
                  surveyQuestionResponse: { id: question.id, responses: [{ id: response.id }] },
                  status: SurveyQuestionStatus.answered,
                })
              }}
              label={render(response)}
            />
          </Cluster>
        ))}
      </Stack>
    </Stack>
  )
}
